import { MinusIcon } from "@otomoro/components/icons/Minus"
import { PlusIcon } from "@otomoro/components/icons/Plus"
import { AppText } from "@otomoro/components/shared/AppText"
import { AppTitle } from "@otomoro/components/shared/AppTitle"
import { SanityImage } from "@otomoro/components/shared/SanityImage"
import { PortableText, PortableTextComponents } from "next-sanity"
import { styles, StepVariants } from "./Step.css"
import { MouseEvent } from "react"

interface StepProps extends StepVariants {
  title: string
  description: any
  thumbnail: any
  openIdx: number
  index: number
  toggleDetails: (e: MouseEvent, idx: number) => void
}

export const Step: React.FC<StepProps> = ({ title, description, thumbnail, index, openIdx, toggleDetails }) => {
  const descriptionComponent = {
		block: {
			normal: ({ children }: any) => (
				<AppText as="p" size="small" weight="medium" color="white" className="mt-[1.5rem] pb-2 md:max-w-[42ch]"
				>
					{children}
				</AppText>
			),
		},
		marks: {
			highlight: ({ children }: any) => <span className="text-mainPink">{children}</span>,
		},
	} as PortableTextComponents

  const { stepHeaderMobile } = styles()

  return (
    <details open={index === openIdx} onClick={(e) => toggleDetails(e, index)}>
      <summary className={stepHeaderMobile()}>
        <AppTitle
          as="h3"
          variant="h3"
          color={index === openIdx ? 'mainPink' : 'white'}
          textTransform="uppercase"
          className="w-full"
        >
          {title}
        </AppTitle>
        {index === openIdx ?
          <MinusIcon className="w-[1.4rem] h-[1.4rem]" active/>
        :
          <PlusIcon className="w-[1.4rem] h-[1.4rem]" theme="dark"/>
        }
      </summary>
      <div className="md:mx-auto w-fit">
        <SanityImage className="w-full object-cover h-full" figureClass="rounded-[0.56rem] overflow-hidden h-[18rem] md:max-w-[60vw] md:h-[36rem]"  image={thumbnail.image} alt={thumbnail.alt} sizes='100vw'/>
        <PortableText value={description} components={descriptionComponent}/>
      </div>
    </details>
  )
}
